"use strict";

require("core-js/modules/es.array.reduce.js");

var _regeneratorRuntime = require("/home/circleci/project/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/home/circleci/project/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/home/circleci/project/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zodResolver = void 0;

var react_hook_form_1 = require("react-hook-form");

var convertArrayToPathName_1 = require("./utils/convertArrayToPathName");

var parseErrorSchema = function parseErrorSchema(zodError, validateAllFieldCriteria) {
  if (zodError.isEmpty) {
    return {};
  }

  return zodError.errors.reduce(function (previous, _ref) {
    var path = _ref.path,
        message = _ref.message,
        type = _ref.code;
    var currentPath = convertArrayToPathName_1.default(path);
    return Object.assign(Object.assign({}, previous), path ? previous[currentPath] && validateAllFieldCriteria ? _defineProperty({}, currentPath, react_hook_form_1.appendErrors(currentPath, validateAllFieldCriteria, previous, type, message)) : _defineProperty({}, currentPath, previous[currentPath] || Object.assign({
      message: message,
      type: type
    }, validateAllFieldCriteria ? {
      types: _defineProperty({}, type, message || true)
    } : {})) : {});
  }, {});
};

var zodResolver = function zodResolver(schema, options) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, _) {
      var validateAllFieldCriteria,
          result,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              validateAllFieldCriteria = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
              result = schema.safeParse(values, options);

              if (!result.success) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", {
                values: result.data,
                errors: {}
              });

            case 4:
              return _context.abrupt("return", {
                values: {},
                errors: react_hook_form_1.transformToNestObject(parseErrorSchema(result.error, validateAllFieldCriteria))
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.zodResolver = zodResolver;